// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  height: 80px;
  z-index: 999;
}

.custom-footer .footer-container {
  display: flex;
  justify-content: space-around; /* center group */
  align-items: center;
  height: 100%;
  padding: 0 10px;
  gap: 10px; /* uniform gap between items */
}

.custom-footer .icon-group-collection,
.custom-footer .icon-group-chit,
.custom-footer .icon-group-history,
.custom-footer .icon-group-eod,
.custom-footer .home-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 11px;
  color: #0e284e;
  padding-top: 8px;
}

.custom-footer ion-icon {
  font-size: 24px;
  margin-bottom: 4px;
  color: #0e284e;
}

.custom-footer .home-button {
  background-color: #0e284e;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  color: white;
  box-shadow: 0 4px 10px #80a5dc;
  z-index: 1000;
  margin: 0 20px; /* <<< This is the key spacing fix */
}

.custom-footer .home-button ion-icon {
  color: white;
  font-size: 30px;
  margin-bottom: 10px;
}

.icon-group-collection ion-icon,
.icon-group-chit ion-icon,
.icon-group-history ion-icon,
.icon-group-eod ion-icon {
  font-size: 24px;
  margin-bottom: 4px;
  fill: #0e284e !important;
  color: #0e284e !important; /* Fills the icon with dark blue */
}

/* Notification badge */
.custom-footer .icon-group-eod {
  position: relative;
}

.custom-footer .icon-group-eod .badge {
  position: absolute;
  top: 8px;
  right: 18px;
  color: white;
  border-radius: 50%;
  font-size: 10px;
  padding: 2px 5px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/collection-app-navbar/collection-app-navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,0CAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,6BAAA,EAAA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA,EAAA,8BAAA;AACF;;AAGA;;;;;EAME,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EAEA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EAEA,aAAA;EACA,cAAA,EAAA,oCAAA;AAHF;;AAMA;EACE,YAAA;EACA,eAAA;EACA,mBAAA;AAHF;;AAMA;;;;EAIE,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,yBAAA,EAAA,kCAAA;AAHF;;AAMA,uBAAA;AACA;EACE,kBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAJF","sourcesContent":[".custom-footer {\r\n  position: fixed;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background: white;\r\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\r\n  height: 80px;\r\n  z-index: 999;\r\n}\r\n\r\n.custom-footer .footer-container {\r\n  display: flex;\r\n  justify-content: space-around; /* center group */\r\n  align-items: center;\r\n  height: 100%;\r\n  padding: 0 10px;\r\n  gap: 10px; /* uniform gap between items */\r\n}\r\n\r\n\r\n.custom-footer .icon-group-collection,\r\n.custom-footer .icon-group-chit,\r\n.custom-footer .icon-group-history,\r\n.custom-footer .icon-group-eod,\r\n.custom-footer .home-button {\r\n  // background-color:#0e284e;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 11px;\r\n  // color: white;\r\n  color:#0e284e;\r\n  padding-top: 8px;\r\n}\r\n\r\n.custom-footer ion-icon {\r\n  font-size: 24px;\r\n  margin-bottom: 4px;\r\n  color: #0e284e;\r\n}\r\n\r\n.custom-footer .home-button {\r\n  background-color: #0e284e;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: white;\r\n  box-shadow: 0 4px 10px #80a5dc;\r\n  // border: 5px solid white;\r\n  z-index: 1000;\r\n  margin: 0 20px; /* <<< This is the key spacing fix */\r\n}\r\n\r\n.custom-footer .home-button ion-icon {\r\n  color: white;\r\n  font-size: 30px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.icon-group-collection ion-icon,\r\n.icon-group-chit ion-icon,\r\n.icon-group-history ion-icon,\r\n.icon-group-eod ion-icon {\r\n  font-size: 24px;\r\n  margin-bottom: 4px;\r\n  fill:#0e284e !important;\r\n  color: #0e284e !important; /* Fills the icon with dark blue */\r\n}\r\n\r\n/* Notification badge */\r\n.custom-footer .icon-group-eod {\r\n  position: relative;\r\n}\r\n\r\n.custom-footer .icon-group-eod .badge {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 18px;\r\n  // background-color: red;\r\n  color: white;\r\n  border-radius: 50%;\r\n  font-size: 10px;\r\n  padding: 2px 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
